import { Col, Container, Row } from "react-bootstrap";
import { BsFillDoorOpenFill, BsFillHouseFill, BsWifi } from "react-icons/bs";
import { BiSolidBed, BiSolidBath } from "react-icons/bi";
import { FaCouch, FaSwimmingPool } from "react-icons/fa";
import { IconType } from "react-icons";
import { StyledImage } from "../Styles";

// https://www.vrbo.com/en-ca/cottage-rental/p515047vb?

interface FeatureItem {
  icon: IconType;
  header: string;
  description?: string;
  items?: string[];
}

const features: FeatureItem[] = [
  {
    icon: BsFillHouseFill,
    header: "Condo",
    items: [
      "1081 sq. ft",
      "Sleeps up to 6",
      "Top floor condo for quiet sleeping",
      "Lots of parking available for your vehicles",
      "Elevator on site",
    ],
  },
  {
    icon: BsFillDoorOpenFill,
    header: "Amenities",
    items: [
      "Fully equipped kitchen",
      "Washer and dryer",
      "Central air and heat",
      "Iron and ironing board",
      "Telephone service",
      "Patio with table and chairs",
      "TVs in all rooms",
      "1 minute walk to pool and clubhouse",
    ],
  },
  {
    icon: BiSolidBed,
    header: "2 Bedrooms",
    items: [
      "1 King",
      "1 Queen / Bunk bed (Twin on top, Full on bottom)",
    ],
  },
  {
    icon: BiSolidBath,
    header: "2 Bathrooms",
    description: "All linens, bath towels and pool towels are provided",
    items: [
      "1 Stand-up shower",
      "1 Tub shower combo",
    ],
  },
  {
    icon: FaCouch,
    header: "Living Spaces",
    items: [
      "Living Room",
      "Kitchen",
      "Dining Area",
      "Balcony",
    ],
  },
  {
    icon: FaSwimmingPool,
    header: "Resort Amenities",
    items: [
      "Large heated pool",
      "Water park",
      "Exercise room",
      "Game room (ping pong, pool tables, video games)",
      "40-seat theatre",
      "2 playgrounds",
      "Tennis and Pickleball courts",
      "Volleyball and basketball courts",
      "Miniature golf",
      "Guest services",
    ],
  },
  {
    icon: BsWifi,
    header: "WIFI Included",
  },
];

export default function About() {
  return (
    <>
      <Container style={{ minHeight: "600px" }}>
        <Row xs={1} md={2}>
          <Col className="mb-4">
            <div className="d-flex flex-column">
              {features.map((feature, index) => {
                const IconComponent = feature.icon;
                return (
                  <div key={index} className="d-flex align-items-start">
                    <IconComponent style={{ margin: "0.5rem" }} size={32} />
                    <div>
                      <h5 style={{ margin: 0 }}>
                        <b>{feature.header}</b>
                      </h5>
                      {feature.description && (
                        <p className="mb-0 text-start">{feature.description}</p>
                      )}
                      {feature.items && (
                        <ul className={feature.description ? "pl-4" : ""}>
                          {feature.items.map((item, itemIndex) => (
                            <li key={itemIndex}>{item}</li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
          <Col>
            <StyledImage src='/images/main/optimized/home-chairs.JPG' />
            <StyledImage src='/images/main/optimized/room-IMG_20260118_152608.jpg' />
            <StyledImage src='/images/main/optimized/room-front-page-pool.webp' />
          </Col>
        </Row>
      </Container >
    </>
  );
}
